module.exports = __webpack_public_path__ + "img/poly-6.b8887a0a.png";